import React, { useEffect, useState } from "react";
import Sidebar from "../sidebar/sidebar";
import { createData, deleteData, getList, updateData } from "../../hooks/api/utils";
import Loader from "../../components/loader/loader";
import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import CommonModal from "../../components/modal/modal";
import Select from "react-select";

const CountryControl = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedCountryId, setSelectedCountryId] = useState(null);
  const [selectedCountryName, setSelectedCountryName] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [countryOptions, setCountryOptions] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const pageCount = Math.ceil((data?.length || 0) / pageSize);

  const fetchBlacklistedCountries = async () => {
    setLoading(true);
    await getList("/admin-panel/black-listed-country/", setLoading, setData);
  };

  const fetchCountryList = async () => {
    await getList("/admin-panel/country-list/", setLoading, (res) => {
      const formatted = res.map((c) => ({ value: c.id, label: c.name }));
      setCountryOptions(formatted);
    });
  };

  useEffect(() => {
    fetchBlacklistedCountries();
  }, []);

  const handlePageClick = (p) => setPage(p);

  const confirmDelete = async () => {
    if (!selectedCountryId) return;
    await deleteData("/admin-panel/block-country/", selectedCountryId);
    setSelectedCountryId(null);
    setIsDeleteModalOpen(false);
    fetchBlacklistedCountries();
  };

const handleAddCountries = async () => {
  if (selectedCountries.length === 0) return;

  setLoading(true);

  try {
    for (const country of selectedCountries) {
      await createData(
        `/admin-panel/block-country/`,
        () => {}, 
        { country_id: country.value },
        () => {},
        ""
      );
    }

    setIsAddModalOpen(false);
    setSelectedCountries([]);

     await new Promise((resolve) => setTimeout(resolve, 500));
    await fetchBlacklistedCountries(); 
  } finally {
    setLoading(false); // ensure loading ends
  }
};

  const currentData = data.slice((page - 1) * pageSize, page * pageSize);

  return (
    <>
      <div className="rightContent">
        <div className="viewMain">
          <div className="row">
            <div className="col-md-12 bg-white left-col p-2">
              <div className="d-flex justify-content-between align-items-center mt-4 p-4">
                <h4>Blacklisted Country List</h4>
                <div className="d-flex justify-content-end blue-btn-container">
                  <button
                    className="blue_btn"
                    onClick={() => {
                      fetchCountryList();
                      setIsAddModalOpen(true);
                    }}
                  >
                    Add Country
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="pateintData">
                    <div className="treatmentData tableTransactionData table-responsive">
                      <table className="table equal-spacing-table">
                        <thead className="tableTransactionHead">
                          <tr>
                            <th>Id</th>
                            <th>Country</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody className="tableData-color">
                          { currentData?.length > 0 ? (
                            currentData.map((country, idx) => (
                              <tr key={idx}>
                                <td>{country.id}</td>
                                <td>{country.name}</td>
                                <td>
                                  <button
                                    className="border-0 bg-transparent"
                                    onClick={() => {
                                      setSelectedCountryId(country.id);
                                      setSelectedCountryName(country.name);
                                      setIsDeleteModalOpen(true);
                                    }}
                                  >
                                    <img
                                      src="images/unblockIcon.svg"
                                      width="20"
                                      className="img-fluid"
                                      alt="delete"
                                      title="Unblock"
                                    />
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center">
                                No blocked countries.
                              </td>
                            </tr>
                          )
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <ResponsivePagination
                    className="pagination justify-content-center mt-5"
                    current={page}
                    total={pageCount}
                    onPageChange={handlePageClick}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <CommonModal
        isOpen={isDeleteModalOpen}
        onRequestClose={() => {
          setIsDeleteModalOpen(false);
          setSelectedCountryId(null);
          setSelectedCountryName("");
        }}
        title="Confirm unblock"
      >
        <p className="text-center mb-4">
          Are you sure you want to unblock <b>{selectedCountryName}</b> country?
        </p>
        <div className="d-flex justify-content-end gap-3">
          <button
            className="transparent_btn"
            onClick={() => {
              setIsDeleteModalOpen(false);
              setSelectedCountryId(null);
              setSelectedCountryName("");
            }}
          >
            Cancel
          </button>
          <button className="red_btn" onClick={confirmDelete}>
            Confirm
          </button>
        </div>
      </CommonModal>

      {/* Add Country Modal */}
      <CommonModal
        isOpen={isAddModalOpen}
        onRequestClose={() => setIsAddModalOpen(false)}
        title="Add Country"
      >
        <div className="mb-3">
          <label className="form-label">Select Country</label>
          <Select
            options={countryOptions}
            isMulti
            isSearchable
            value={selectedCountries}
            onChange={setSelectedCountries}
            placeholder="Enter"
          />
        </div>
        <div className="d-flex justify-content-end">
          <button
            className="transparent_btn me-2"
            onClick={() => setIsAddModalOpen(false)}
          >
            Cancel
          </button>
          <button
            className="blue_btn"
            onClick={handleAddCountries}
            disabled={selectedCountries.length === 0 || loading}
          >
            Save
          </button>
        </div>
      </CommonModal>
      </>
  );
};

export default CountryControl;
